function escapeRegExp (value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

/**
 * Splits `text` into parts, marking the ones that match a word of `query` (case-insensitive),
 * so the template can render the matches without v-html.
 *
 * highlight('Heftrucktraining Basis', 'heft bas')
 *   → [{ text: 'Heft', match: true }, { text: 'rucktraining ', match: false }, { text: 'Bas', match: true }, { text: 'is', match: false }]
 */
export function highlight (text, query) {
    const words = query.trim().split(/\s+/).filter(Boolean).map(escapeRegExp)

    if (!text || words.length === 0) {
        return [{ text, match: false }]
    }

    const pattern = new RegExp(`(${words.join('|')})`, 'gi')

    return text
        .split(pattern)
        .filter(part => part !== '')
        .map(part => ({ text: part, match: words.some(word => new RegExp(`^${word}$`, 'i').test(part)) }))
}
